import React from 'react'
import { Modal, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const BuildupDashboardHelpModal = ({ visible, onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  const downloadPdfUrl = `${apiUrl}${apiUrl && !apiUrl.endsWith('/') ? '/' : ''}download_summary_pdf?module=buildup-dashboard`

  return (
    <Modal
      title={
        <div className='buildup-dash-help-header'>
          <span className='buildup-dash-help-header-title'>Build-up Dashboard Summary</span>
        </div>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      centered
      footer={[
        <a key='download' href={downloadPdfUrl} download='Build-up Dashboard summary.pdf'>
          <Button type='primary' className='buildup-dash-help-download-btn' icon={<DownloadOutlined />}>
            Download PDF
          </Button>
        </a>
      ]}
      width={780}
      className='custom-modal buildup-dash-help-modal'
    >
      <div className='buildup-dash-help-content'>
        <div className='buildup-dash-help-card'>
          <div className='buildup-dash-help-title'>Build-up Dashboard</div>
          <p>
            The Buildup dashboard displays all shipments which are currently in a location defined in the Build-Up Area Mapping page of the System Parameters module. By default the dashboard will display all shipments which are booked and/or assigned to a flight. This means that there might be shipments displayed on the dashboard which are not yet received at the station.
          </p>
          <p>
            Users can manipulate the data displayed by changing the filters.
          </p>
        </div>

        <div className='buildup-dash-help-card'>
          <div className='buildup-dash-help-title'>Conditions to Add</div>
          <p>
            As with the Breakdown Dashboard, the build up dashboard is a mirror of the Build up control screen for a particular work area. The shipments currently in this work area will be displayed. To add a shipment in the selected work area - the shipment must be scanned to a location which is defined in the Buildup Area Mapping page.
          </p>
        </div>

        <div className='buildup-dash-help-card'>
          <div className='buildup-dash-help-title'>Conditions to Remove</div>
          <p>
            Data is removed from the dashboard in the following scenarios :-
          </p>
          <ul className='buildup-dash-help-list'>
            <li>
              Closed ULDs are not displayed on the dashboard
            </li>
            <li>
              Shipment is scanned to a gate location or some other location which is not mapped in the Buildup area mapping page.
            </li>
            <li>
              Once the FPE time elapses
            </li>
            <li>
              Shipments which have already received the assignment message can be marked as &apos;Done&apos;. This removes the record off the Build up dashboard and puts it on the Haul-out Dashboard.
            </li>
          </ul>
        </div>

        <div className='buildup-dash-help-card'>
          <div className='buildup-dash-help-title'>Order by</div>
          <p>
            Data is sorted by the FPE- value, where the lowest time to FPE is at the top of the list. Shipments departing on the same flight are grouped together.
          </p>
        </div>

        <div className='buildup-dash-help-card'>
          <div className='buildup-dash-help-title'>Filters</div>
          <p>
            The list can be populated by work area defined in the Build-up work area mapping page. It can be filtered by type of equipment used, whether the destination is International or Domestic or by the shipments product code or location. Cargo at station station filters out the shipments which have or have not received the FSU/MAN message. These shipments are considered as &apos;assigned&apos; and can be marked as &apos;Done&apos; to take the record off the display.
          </p>
        </div>

        <div className='buildup-dash-help-card'>
          <div className='buildup-dash-help-title'>Comments</div>
          <ul className='buildup-dash-help-list'>
            <li>
              The value in the FPE columns will be highlighted in <span className='buildup-dash-text-amber'>amber</span> once the value goes below the threshold set in the Handling times page.
            </li>
            <li>
              If a ULD is built for a narrow-body aircraft, the same would be highlighted in <span className='buildup-dash-text-red'>Red</span>
            </li>
            <li>
              Similarly, if a cart is built for a wide body aircraft, it would be highlighted in <span className='buildup-dash-text-red'>Red</span>
            </li>
            <li>
              The Build-up area mapping page of system parameters module has a field to enter locations which are to be highlighted. If the shipment is scanned to these location it will be highlighted accordingly.
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default BuildupDashboardHelpModal
